import React, { useState } from "react";
import style from "./RadioButton.module.scss";

const RadioButton = (props) => {

  return (
    <React.Fragment>
      <label key={props.keys} className={style.RadioButtonContainer}>
        <input
          type="radio"
          checked={props.value ? 'checked' : ''}
          name={props.secondTag}
          onChange={e => props.onclick(e, props.value, props.tag, props.secondTag)}
          disabled={props.disabled ? props.disabled : false}
        ></input>
        <span className={style.checkmark}></span>
      </label>
      {props.label ? <p className={style.RadioButtonLabel}>{props.label}</p> : ''}
    </React.Fragment>
  );
}

export default RadioButton;

/**
          value={radioButton}
          tag='فیلتر'
          label='اعمال فیلتر'
          onclick={handleRadioButton}
 */